(() => {
  const cachedRules = new Map();
  function loadRules(url) {
    if (!cachedRules.has(url)) {
      cachedRules.set(url, fetch(url, { credentials: 'same-origin' }).then(response => {
        if (!response.ok) throw new Error('Shipping postcode rules unavailable');
        return response.json();
      }).then(rules => {
        if (rules.price !== 99 || rules.currency !== 'AUD' || !Array.isArray(rules.eligible) || !Array.isArray(rules.excluded)) throw new Error('Invalid shipping postcode rules');
        return { eligible: new Set(rules.eligible), excluded: new Set(rules.excluded) };
      }).catch(error => { cachedRules.delete(url); throw error; }));
    }
    return cachedRules.get(url);
  }
  function init() {
    document.querySelectorAll('[data-shipping99]').forEach(root => {
      if (root.dataset.shipping99Ready) return;
      root.dataset.shipping99Ready = 'true';
      const input = root.querySelector('[data-shipping99-postcode]');
      const button = root.querySelector('[data-shipping99-check]');
      const result = root.querySelector('[data-shipping99-result]');
      const messages = JSON.parse(root.querySelector('[data-shipping99-messages]').textContent);
      let requestId = 0;
      async function check() {
        const id = ++requestId;
        const postcode = input.value.trim();
        result.removeAttribute('data-eligible');
        if (!/^\d{4}$/.test(postcode)) {
          input.setAttribute('aria-invalid', 'true');
          result.textContent = messages.invalid;
          return;
        }
        input.removeAttribute('aria-invalid');
        button.disabled = true;
        result.textContent = '';
        try {
          const rules = await loadRules(root.dataset.rulesUrl);
          if (id !== requestId) return;
          const eligible = rules.eligible.has(postcode) && !rules.excluded.has(postcode);
          result.dataset.eligible = String(eligible);
          result.textContent = eligible ? messages.eligible : messages.quote;
        } catch {
          if (id === requestId) result.textContent = messages.unavailable;
        } finally {
          if (id === requestId) button.disabled = false;
        }
      }
      button.addEventListener('click', check);
      input.addEventListener('keydown', event => {
        if (event.key === 'Enter') { event.preventDefault(); check(); }
      });
      input.addEventListener('input', () => {
        ++requestId;
        button.disabled = false;
        result.textContent = '';
        result.removeAttribute('data-eligible');
        input.removeAttribute('aria-invalid');
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
